import { Bidi } from './Bidi'

/**
 * The phone number under a member's name (D178), wherever members are listed.
 *
 * **The guard is the reason this is a component rather than three lines at each call site.**
 * `roster.ts` falls back to the phone as a row's `displayName` when there is no member label and no
 * self-name — which is the *normal* state of a pending invite — so an unguarded second line prints
 * the same number twice under itself. `CopyMembersScreen`'s outcome rows already carried this
 * comparison by hand; it now exists once, and the next surface that lists members inherits it
 * instead of rediscovering it.
 *
 * `phone` is optional on the client's `RosterRow` even though `kind: 'invite'` rows always carry one
 * (it is the grant key): a `kind: 'member'` row gets it from a per-request identity lookup, so the
 * type is honest and this branches rather than asserting.
 *
 * `<Bidi>` is not decoration — §7.2 makes it non-negotiable for a phone number, and this shell is
 * `dir="rtl"`, so an unisolated `+972…` renders with its `+` in the wrong place.
 */
export function MemberPhone({
  phone,
  displayName,
}: {
  readonly phone?: string
  readonly displayName: string
}): JSX.Element | null {
  if (phone === undefined || phone === displayName) return null
  return (
    <div className="row-phone">
      <Bidi>{phone}</Bidi>
    </div>
  )
}
